import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { actions as userActions } from "../../redux/modules/user";
import { get } from "../../utils/request";
import "./style.css";
class PowerfulQuery extends Component {
  componentWillMount() {
    this.requestShareConfig();
  }
  componentDidMount = () => {
    document.title = "浙考之家-万能选科";
  };
  render() {
    return (
      <div>
        <div className="powerfuquery_top">
          <img
            className="powerfuquery_top_background"
            alt=""
            src={require("../../images/powerful/bg.png")}
          ></img>
          <NavLink to="/articledetail/3y1iPj">
            <img
              className="powerfuquery_top_how"
              alt=""
              src={require("../../images/powerful/how.gif")}
            ></img>
          </NavLink>
          <img
            alt=""
            className="powerfuquery_top_subquery"
            src={require("../../images/powerful/subquery.png")}
          ></img>
        </div>
        <div className="powerfuquery_box">
          <NavLink
            onClick={(event) => this.handleJump(event)}
            to="/subjectquery"
            className="powerfuquery_box_item"
          >
            <img
              alt=""
              src={require("../../images/powerful/with_subject.png")}
            ></img>
            <div>按选科查能报考的院校/专业</div>
            <img
              className="powerfuquery_box_item_go"
              alt=""
              src={require("../../images/powerful/with_subject_go.png")}
            ></img>
          </NavLink>
          <NavLink
            onClick={(event) => this.handleJump(event)}
            to="/majorquery"
            className="powerfuquery_box_item"
          >
            <img
              alt=""
              src={require("../../images/powerful/with_major.png")}
            ></img>
            <div>查询专业对应的院校及选科要求</div>
            <img
              className="powerfuquery_box_item_go"
              alt=""
              src={require("../../images/powerful/with_major_go.png")}
            ></img>
          </NavLink>
          <NavLink
            style={{ borderBottom: 0 }}
            to="/school"
            className="powerfuquery_box_item"
          >
            <img
              alt=""
              src={require("../../images/powerful/with_school.png")}
            ></img>
            <div>查询院校开设的专业及选科要求</div>
            <img
              className="powerfuquery_box_item_go"
              alt=""
              src={require("../../images/powerful/with_school_go.png")}
            ></img>
          </NavLink>
        </div>
      </div>
    );
  }
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-万能选科", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-万能选科", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
  handleJump = (event) => {
    let userInfo = this.props.userInfo;
    const { dispatch } = this.props;
    //如果没有登录 ，阻止它跳转，并且弹出登录框
    if (userInfo.isLogin === false) {
      event.preventDefault(); //阻止默认事件
      dispatch(userActions.setShowLogin(true));
    }
  };
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(PowerfulQuery);



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/index.js